import { jsx as _jsx } from "react/jsx-runtime";
import { TranslationInfoButton } from '../Tool/TranslationInfoButton.js';
export const getClickableT = ({ t, resource, prefix, }) => {
    return ((...args) => {
        const text = t(...args);
        const translation = (_jsx(TranslationInfoButton, { resource: resource, prefix: prefix, options: args, children: text }));
        // to support cases where the translation is used as a string within a prop we add string methods so it can be used as a string
        // i.e. <FactSlogan fact={t('Microfrontends')} slogan={t('aSmallStepForMankind')} />
        const result = {
            ...translation,
            at: text.at,
            charAt: text.charAt,
            charCodeAt: text.charCodeAt,
            concat: text.concat,
            endsWith: text.endsWith,
            includes: text.includes,
            indexOf: text.indexOf,
            lastIndexOf: text.lastIndexOf,
            localeCompare: text.localeCompare,
            match: text.match,
            normalize: text.normalize,
            padEnd: text.padEnd,
            padStart: text.padStart,
            repeat: text.repeat,
            replace: text.replace,
            replaceAll: text.replaceAll,
            search: text.search,
            slice: text.slice,
            split: text.split,
            startsWith: text.startsWith,
            substring: text.substring,
            toLocaleLowerCase: text.toLocaleLowerCase,
            toLocaleUpperCase: text.toLocaleUpperCase,
            toLowerCase: text.toLowerCase,
            toUpperCase: text.toUpperCase,
            toString: () => text,
            trim: text.trim,
            trimEnd: text.trimEnd,
            valueOf: text,
        };
        return result;
    });
};
//# sourceMappingURL=getClickableT.js.map